import { render, staticRenderFns } from "./JsonFormStringEnumerable.vue?vue&type=template&id=2b1e28c0&scoped=true"
import script from "./JsonFormStringEnumerable.vue?vue&type=script&lang=ts"
export * from "./JsonFormStringEnumerable.vue?vue&type=script&lang=ts"
import style0 from "./JsonFormStringEnumerable.vue?vue&type=style&index=0&id=2b1e28c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e28c0",
  null
  
)

export default component.exports